module.exports = __webpack_public_path__ + "static/media/operations.95244fd9.svg";